import React from 'react';

/**
 * Catalina Dental — heart-tooth mark wordmark.
 * `light=true` is for use on dark backgrounds (sidebar, login left panel).
 * The PNG is black-on-transparent, so we invert it via filter on dark surfaces.
 */
export default function Logo({ size = 36, showText = true, light = true }) {
  const textColor = light ? '#F5F1E8' : '#0E0E0E';
  const subColor = light ? 'rgba(201, 169, 97, 0.85)' : '#8A6A2A';

  return (
    <div className="flex items-center gap-3" data-testid="catalina-logo">
      <img
        src="/catalina-logo.png"
        alt="Catalina Dental"
        width={size}
        height={size}
        style={{
          filter: light ? 'invert(1) brightness(1.05)' : 'none',
          objectFit: 'contain',
        }}
      />
      {showText && (
        <div className="leading-tight">
          <p
            className="font-heading font-semibold"
            style={{ color: textColor, fontSize: 14, letterSpacing: '0.18em', lineHeight: '1.1' }}
          >
            CATALINA
          </p>
          <p
            className="font-body"
            style={{ color: subColor, fontSize: 9.5, letterSpacing: '0.32em' }}
          >
            PERFORMANCE HUB
          </p>
        </div>
      )}
    </div>
  );
}
